import PropTypes from "prop-types"
import React from "react"

const sectionStyles = {
  padding: `5rem 2rem`,
  margin: `0 auto`,
  maxWidth: `1400px`
};

const subSectionContainer = {
  display: `flex`,
  justifyContent: `space-evenly`,
  flexWrap: `wrap`,
};

const skillContainerStyles = {
  textAlign: `center`,
  marginBottom: `2rem`,
  maxWidth: `275px`
};

const SkillsSection = ({ skills }) => (
  <section id="skills" style={sectionStyles}>
    <h1 className="section-header">Skills</h1>
    <div style={subSectionContainer}>
      {skills.map((skill, index) => (
        <div key={index} style={skillContainerStyles}>
          <div className="skill-icons">
            {skill.icons.map(icon => icon)}
          </div>
          <div>
            {skill.description}
          </div>
        </div>
      ))}
    </div>
  </section>
)

SkillsSection.propTypes = {
  skills: PropTypes.arrayOf(PropTypes.shape({
    icons: PropTypes.arrayOf(PropTypes.element),
    description: PropTypes.string,
  })),
}

SkillsSection.defaultProps = {
  skills: {},
}

export default SkillsSection
